module.exports = __webpack_public_path__ + "img/congo.426e373b.svg";